import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { InstantWinEvent } from 'models/instantWinEvent';
import { InstantWinLotteryModal } from 'components/InstantWinLotteryModal/InstantWinLotteryModal';
import { ReduxState } from 'ducks';

interface Props {
  instantWinEvent: InstantWinEvent;
}

export const InstantWinPopup = ({ instantWinEvent }: Props) => {
  const { t } = useTranslation();
  const [openInstantWinLotteryModal, setOpenInstantWinLotteryModal] = React.useState(false);
  const settings = useSelector((state: ReduxState) => state.server.settings.all);

  const handleOpenInstantWinPage = () => {
    setOpenInstantWinLotteryModal(true);
  };

  const instantWinSettings = settings.instant_win_settings;

  const getBorderRadiusValue = (buttonStyle: string) => {
    if (buttonStyle === 'ROUND') {
      return '50%';
    } else if (buttonStyle === 'ROUNDED_CORNERS_LARGE') {
      return '24px';
    } else if (buttonStyle === 'ROUNDED_CORNERS_SMALL') {
      return '12px';
    }
    return '';
  };

  const position =
    instantWinSettings?.button_position === 'LEFT_BOTTOM' ? { left: '15px' } : { right: '15px' };

  return (
    <>
      <button
        onClick={() => {
          handleOpenInstantWinPage();
        }}
        style={{
          height: `${instantWinSettings?.button_height ?? 40}px`,
          width: `${instantWinSettings?.button_width ?? 160}px`,
          fontWeight: 'bold',
          color: `${instantWinSettings?.button_text_color ?? '#fff'}`,
          fontSize: '18px',
          backgroundColor: `${instantWinSettings?.button_color ?? '#008ec9'}`,
          borderRadius: `${getBorderRadiusValue(
            instantWinSettings?.button_style ?? 'SQUARE_CORNERS'
          )}`,
          position: 'fixed',
          cursor: 'pointer',
          bottom: '65px',
          zIndex: 100,
          ...position,
        }}
      >
        <div>{instantWinSettings?.button_text || t('Button Text')}</div>
      </button>
      {openInstantWinLotteryModal && (
        <InstantWinLotteryModal
          instantWinEvent={instantWinEvent}
          open={openInstantWinLotteryModal}
          onClose={() => setOpenInstantWinLotteryModal(false)}
        />
      )}
    </>
  );
};
